import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import job from "./modules/job";
import app from "./modules/app";
import user from "./modules/user";
import socket from "./modules/socket";
import card from "./modules/card";

Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    auth: {
      namespaced: true,
      state: auth.state,
      mutations: auth.mutations,
      getters: auth.getters,
      actions: auth.actions,
    },
    app:{
      namespaced:true,
      state: app.state,
      mutations: app.mutations,
      getters: app.getters,
      actions: app.actions
    },
    job:{
      namespaced:true,
      state: job.state,
      mutations: job.mutations,
      getters: job.getters,
      actions: job.actions
    },
    card:{
      namespaced:true,
      state: card.state,
      mutations: card.mutations,
      getters: card.getters,
      actions: card.actions
    },
    user:{
      namespaced:true,
      state: user.state,
      // mutations: job.mutations,
      // getters: job.getters,
      actions: user.actions
    },
    socket:{
      namespaced:true,
      state: socket.state,
      mutations: socket.mutations,
      getters: socket.getters,
      actions: socket.actions,
    },
  }
});
